"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const safeInvoke_1 = require("../../../utils/safeInvoke");
const HandlebarsTemplateFormatter_1 = tslib_1.__importDefault(require("../HandlebarsTemplateFormatter"));
const setOnMissingPropStringifierProxy_1 = tslib_1.__importDefault(require("./setOnMissingPropStringifierProxy"));
const previewContext = {
    activity: {
        title: 'Sunday run',
        description: 'Geese 🦆',
        type: 'run',
        duration: '01:23:45',
        date: 'Sun Jan 17 2021',
        url: 'https://www.strava.com/activities/9999999999',
    },
    playlist: {
        title: 'Playlist for my Sunday run',
        url: 'https://open.spotify.com/playlist/1234567890abcdefghijkl',
        tracklist: `Tracklist:\n00:01:23 Sunday - Easy Life\n00:04:56 Me and My Friends - CRi Remix - CRi, Sophia Bel`,
        tracks: [
            {
                title: 'Sunday',
                album: 'Spaceships Mixtape',
                artist: 'Easy Life',
                duration: '00:03:22',
                startTime: '13:26:45',
            },
            {
                title: 'Me and My Friends - CRi Remix',
                album: 'Me and My Friends: Remixes',
                artist: 'CRi, Sophia Bel',
                duration: '00:05:33',
                startTime: '13:30:08',
            },
        ],
    },
    meta: {
        app: 'MoovinGroovin',
    },
};
const getProxyContext = lodash_1.memoize(setOnMissingPropStringifierProxy_1.default, (ctx, missingVal) => JSON.stringify(ctx !== null && ctx !== void 0 ? ctx : {}) + `__${missingVal}`);
const validateTemplate = (template, options = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { context = previewContext, formatter = new HandlebarsTemplateFormatter_1.default() } = options;
    yield formatter.install();
    const proxiedContext = getProxyContext(context, 'UNKNOWN');
    const { result, error } = yield safeInvoke_1.asyncSafeInvoke(() => formatter.format(template, proxiedContext));
    return {
        result,
        error,
    };
});
exports.default = lodash_1.memoize(validateTemplate, (template, { context, formatter } = {}) => `${formatter === null || formatter === void 0 ? void 0 : formatter.name}__${JSON.stringify(context !== null && context !== void 0 ? context : {})}__${template}`);
//# sourceMappingURL=validateTemplate.js.map